/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeatureAccessDeniedEventDto } from './FeatureAccessDeniedEventDto';
import {
    FeatureAccessDeniedEventDtoFromJSON,
    FeatureAccessDeniedEventDtoFromJSONTyped,
    FeatureAccessDeniedEventDtoToJSON,
    FeatureAccessDeniedEventDtoToJSONTyped,
} from './FeatureAccessDeniedEventDto';

/**
 * Paginated list of feature access denied events. Use total with page and pageSize to compute total pages (e.g. totalPages = ceil(total / pageSize)).
 * @export
 * @interface FeatureAccessDeniedEventsResponse
 */
export interface FeatureAccessDeniedEventsResponse {
    /**
     * Whether the request succeeded
     * @type {boolean}
     * @memberof FeatureAccessDeniedEventsResponse
     */
    success?: boolean;
    /**
     * Events for the requested page (current page only)
     * @type {Array<FeatureAccessDeniedEventDto>}
     * @memberof FeatureAccessDeniedEventsResponse
     */
    data?: Array<FeatureAccessDeniedEventDto>;
    /**
     * Total count of events across all pages (for pagination)
     * @type {number}
     * @memberof FeatureAccessDeniedEventsResponse
     */
    total?: number;
    /**
     * Requested page number (1-based)
     * @type {number}
     * @memberof FeatureAccessDeniedEventsResponse
     */
    page?: number;
    /**
     * Requested page size
     * @type {number}
     * @memberof FeatureAccessDeniedEventsResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the FeatureAccessDeniedEventsResponse interface.
 */
export function instanceOfFeatureAccessDeniedEventsResponse(value: object): value is FeatureAccessDeniedEventsResponse {
    return true;
}

export function FeatureAccessDeniedEventsResponseFromJSON(json: any): FeatureAccessDeniedEventsResponse {
    return FeatureAccessDeniedEventsResponseFromJSONTyped(json, false);
}

export function FeatureAccessDeniedEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureAccessDeniedEventsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FeatureAccessDeniedEventDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function FeatureAccessDeniedEventsResponseToJSON(json: any): FeatureAccessDeniedEventsResponse {
    return FeatureAccessDeniedEventsResponseToJSONTyped(json, false);
}

export function FeatureAccessDeniedEventsResponseToJSONTyped(value?: FeatureAccessDeniedEventsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FeatureAccessDeniedEventDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

